import { http, httpV2 } from "@/api/index";

const Qs = require("qs");

/**
 * Solicita os registros de tendência para um ativo. Requisição para versão 1.0.
 * @param {object} parameters Parametros necessários para a requisição (evoluir para um model).
 * @returns Array com os registros de tendência disponíveis.
 */
const Get = function(parameters)
{
	 const params = {};
	 params.startDateTime = parameters.startDateTime;
	 params.endDateTime = parameters.endDateTime;

	 return http.get("/TrendSignalRecords",
		 {
			 params:           parameters,
			 headers:          { dateTimeFormat: parameters.dateTimeFormat },
			 paramsSerializer: params => Qs.stringify(params, { encode: false }),
		 });
};

/**
 * Solicita os registros de tendência para um ativo. Requisição para versão 2.0.
 * @param {object} parameters Parametros necessários para a requisição (evoluir para um model).
 * @returns Array com os registros de tendência disponíveis.
 */
const GetV2 = function(parameters)
{
	const params = {};
	params.startDateTime = parameters.startDateTime;
	params.endDateTime = parameters.endDateTime;

	return httpV2.get("/TrendSignalRecords",
		{
			params:           parameters,
			headers:          { dateTimeFormat: parameters.dateTimeFormat },
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Solicita os registros estratificados de tendência para um ativo. Requisição para versão 2.0.
 * @param {object} parameters Parametros necessários para a requisição (evoluir para um model).
 * @returns Array com os registros estratificados de tendência disponíveis.
 */
const GetWithStratificationV2 = function(parameters)
{
	return httpV2.get("/TrendSignalRecords/Stratification",
		{
			params:           parameters,
			headers:          { dateTimeFormat: parameters.dateTimeFormat },
			paramsSerializer: params => Qs.stringify(params, { allowDots: true, arrayFormat: "indices" }),
		});
};

/**
 * Solicita os últimos registros de tendência para cada id enviado. Requisição para versão 2.0.
 * @param {number[]} trendSignalSettingIds Parametros necessários para a requisição (evoluir para um model).
 * @returns Array com os registros de últimos registros de tendência disponíveis.
 */
const GetLastTrendRecords = function(trendSignalSettingIds = [])
{
	return httpV2.get("/TrendSignalRecords/LastTrendRecords",
		{
			params:           { trendSignalSettingIds },
			headers:          { dateTimeFormat: "dd/MM/yyyy hh:mm" },
			paramsSerializer: trendSignalSettingIds => Qs.stringify(trendSignalSettingIds,
				{ arrayFormat: "repeat" }),
		});
};

/**
 * Solicita os eventos de manutenção e inspeção para um ativo.
 * @param {object} parameters Parametros necessários para a requisição.
 * @returns Array com os eventos de manutenção e inspeção.
 */
const GetMaintenanceEventRecords = function(parameters)
{
	const params = {};
	params.startDateTime = parameters.startDateTime;
	params.endDateTime = parameters.endDateTime;

	return httpV2.get(`/TrendSignalRecords/${parameters.monitoringElementId}/MaintenanceEventRecords`,
		{
			params:           params,
			headers:          { dateTimeFormat: parameters.dateTimeFormat },
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Requisição para o download dos valores dos sinais de tendências em arquivo .csv.
 * @param {object} parameters - Parâmetros necessários para a requisição.
 * @returns {object} Arquivo no formato csv para download.
 */
const DownloadCSV = function(parameters)
{
	return httpV2.post("/TrendSignalRecords/DownloadCSV", parameters);
};

/**
 * Requisição para o download dos valores dos sinais de tendências estratificados em arquivo .csv.
 * @param {object} parameters - Parâmetros necessários para a requisição.
 * @param {string} fileName - Nome do arquivo csv.
 * @returns {object} Arquivo no formato csv para download.
 */
const DownloadCSVWithStratification = function(parameters, fileName)
{
	const params = {};
	params.stratificationParameters = parameters;
	params.fileName = fileName;
	return httpV2.post("/TrendSignalRecords/Stratification/DownloadCSV", params);
};

export default {
	Get,
	GetV2,
	GetWithStratificationV2,
	GetLastTrendRecords,
	GetMaintenanceEventRecords,
	DownloadCSV,
	DownloadCSVWithStratification,
};